import { FC } from 'react';
import { Text } from '@chakra-ui/react';

import {
  convertToType,
  formatNumberAsString,
  preserveEmpty,
} from '~/core/application/workflow/utils/transformFuncs';
import { WorkflowStepFormFieldNumberInput } from '../types/workflowStepComponentTypes';
import { FieldToBlock, FieldValueProps } from './declarations';
import { commonFieldBlockProps } from './FieldUtils';

export const NumberFieldToBlock: FieldToBlock<
  'number',
  WorkflowStepFormFieldNumberInput
> = (field) => ({
  ...commonFieldBlockProps(field),
  componentType: 'number-input',
  transformFuncsIn: [formatNumberAsString],
  transformFuncsOut: [preserveEmpty(convertToType('number'))],
  size: 'sm',
});

type NumberFieldValueProps = FieldValueProps<'number'>;

export const NumberFieldValue: FC<NumberFieldValueProps> = ({ field }) => {
  const value = formatNumberAsString(field.value ?? 0);

  return <Text>{value}</Text>;
};
